import styled, { css } from 'styled-components';
import { AnswerModal } from './AnswerModal';
import React from 'react';
import { useGame } from '../providers/GameProvider/GameProvider';
import { Category } from '../data/categories';

const Cell = styled.button<{ $img?: string }>(
  ({ theme, $img }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${theme.mode === 'dark' ? '#d1d5db' : theme.paper.default};
    background-size: auto 105%;
    background-position: center;
    font-family: Jost;
    font-weight: 400;
    font-size: 1rem;
    background-color: ${theme.mode === 'dark'
      ? theme.paper.default
      : '#d1d5db'};
    color: ${theme.text.default};
    padding: 0;
    margin: ${theme.mode === 'dark' ? '0' : '0.25rem'};
    border-radius: ${theme.mode === 'dark' ? '0' : '0.8rem'};
    cursor: pointer;
    text-align: center;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;

    transition: all 0.1s ease;

    &[aria-disabled] {
      cursor: default;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid ${theme.border.focus};
    }

    &:hover:not([aria-disabled]) {
      filter: grayscale(80%);
      background-size: auto 110%;
    }

    ${$img &&
    css`
      background-image: url(${$img});
    `}

    @media (max-width: 630px) {
      font-size: 0.7rem;
      margin: ${theme.mode === 'dark' ? '0' : '0.12rem'};
      border-radius: ${theme.mode === 'dark' ? '0' : '0.5rem'};
    }
  `
);

const AnswerText = styled.span(
  ({ theme }) => css`
    height: 100%;
    width: 100%;
    background: ${theme.paper.default}DD;
    color: ${theme.text.default};
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  `
);

interface AnswerCellProps {
  img?: string;
  yAxisQuestion: Category;
  xAxisQuestion: Category;
}

export function AnswerCell({
  img,
  yAxisQuestion,
  xAxisQuestion,
}: AnswerCellProps) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const question = `${yAxisQuestion} / ${xAxisQuestion}`;

  const { answers, gameState } = useGame();

  const content = answers[question];

  const gameOver = ['won', 'lost'].includes(gameState);

  function handleOpenModal() {
    if (gameOver || content) return;
    setIsModalOpen(true);
  }

  function handleCloseModal() {
    setIsModalOpen(false);
  }

  return (
    <>
      <Cell
        aria-label={question}
        aria-disabled={gameOver || content ? 'true' : undefined}
        disabled={Boolean(gameOver || content)}
        onClick={handleOpenModal}
        $img={img}
      >
        {answers[question] && <AnswerText>{answers[question]}</AnswerText>}
      </Cell>

      <AnswerModal
        question1={yAxisQuestion}
        question2={xAxisQuestion}
        questionId={question}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
}
